var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/quickshop-actions/quickshop-remove-confirmation.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"c-confirm-remove c-product-remove-from-cart-prompt__hidden js-remove-from-cart-prompt\">\n\n\t<p class=\"c-confirm-remove__p\">\n\n\t\t";
if(runtime.contextOrFrameLookup(context, frame, "wishlist")) {
output += "\n\n\t\t\t";
output += runtime.suppressValue((lineno = 6, colno = 5, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_remove-from-wishlist-confirmation"])), env.opts.autoescape);
output += "\n\n\t\t";
;
}
else {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"showRegistryQuantity")) {
output += "\n\n\t\t\t";
output += runtime.suppressValue((lineno = 10, colno = 5, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_remove-from-registry-confirmation"])), env.opts.autoescape);
output += "\n\n\t\t";
;
}
;
}
output += "\n\n\t</p>\n\n    <div class=\"o-row c-confirm-remove-controls--outer\">\n        \n        <a href=\"#\" class=\"c-confirm-remove-controls__button c-confirm-remove-controls__button--first js-remove-from-cart-confirm\" data-qa-remove-from-cart-confirm>\n\n            ";
output += runtime.suppressValue((lineno = 20, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_links-remove-confirm"])), env.opts.autoescape);
output += "\n\n        </a>\n\n        <a href=\"#\" class=\"c-confirm-remove-controls__button c-confirm-remove-controls__button--last js-remove-from-cart-decline\">\n\n            ";
output += runtime.suppressValue((lineno = 26, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_links-remove-decline"])), env.opts.autoescape);
output += "\n\n        </a>\n\n    </div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/quickshop-actions/quickshop-remove-confirmation.j2"] , dependencies)